import { useState, useCallback } from "react";
import { useCookieConsent as useCookieConsentContext } from "@/contexts/CookieConsentContext";

export function useCookieConsentBanner() {
  const { preferences, acceptAll, rejectAll, savePreferences } =
    useCookieConsentContext();
  const [showPreferenceCenter, setShowPreferenceCenter] = useState(false);

  const isVisible = !preferences.hasConsented;

  const handleAcceptAll = useCallback(() => {
    acceptAll();
  }, [acceptAll]);

  const handleRejectAll = useCallback(() => {
    rejectAll();
  }, [rejectAll]);

  const handleCustomize = useCallback(() => {
    setShowPreferenceCenter(true);
  }, []);

  const handleClosePreferenceCenter = useCallback(() => {
    setShowPreferenceCenter(false);
  }, []);

  const handleSavePreferences = useCallback(
    (analytics: boolean) => {
      savePreferences(analytics);
      setShowPreferenceCenter(false);
    },
    [savePreferences],
  );

  return {
    isVisible,
    showPreferenceCenter,
    preferences,
    handleAcceptAll,
    handleRejectAll,
    handleCustomize,
    handleClosePreferenceCenter,
    handleSavePreferences,
  };
}
